import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components'; // @ts-expect-error svg import

import HERO_BG from 'bender-url!pricing-pages-ui/img/ebx633/hero-bg.svg';
import UIImage from 'UIComponents/image/UIImage';
import SplashPageHeader from '../splash-page/SplashPageHeader';
const PageHeader = styled.header.withConfig({
  displayName: "Ebx633HeroBanner__PageHeader",
  componentId: "od4gcj-0"
})(["position:relative;width:100%;height:136px;display:flex;flex-direction:column;justify-content:center;align-items:center;z-index:-1;"]);
const HeroContainer = styled.div.withConfig({
  displayName: "Ebx633HeroBanner__HeroContainer",
  componentId: "od4gcj-1"
})(["top:30px;position:absolute;"]);
const HeroBackground = styled(UIImage).withConfig({
  displayName: "Ebx633HeroBanner__HeroBackground",
  componentId: "od4gcj-2"
})(["position:absolute;width:100vw;top:0;"]);

const Ebx633Header = () => {
  return /*#__PURE__*/_jsxs(PageHeader, {
    children: [/*#__PURE__*/_jsx(HeroBackground, {
      src: HERO_BG
    }), /*#__PURE__*/_jsx(HeroContainer, {
      children: /*#__PURE__*/_jsx(SplashPageHeader, {
        titleKey: "pricingPage.pages.ebx633SuiteStarter.title",
        subtitleKey: "pricingPage.pages.ebx633SuiteStarter.subtitle"
      })
    })]
  });
};

export default Ebx633Header;